//import 'bootstrap';

import "./postsJS/posts-testimonials";
import "./utils/counter-animation";
import "./utils/accordions";
import "./utils/gallery-lightbox";
import mobileNav from "./nav/mobile-nav";
import desktopNav from "./nav/desktop-nav";
import scrollIntoContact from "./section/scroll-into-contact";
import "./forms/gf-general";
import './utils/back-to-top';

document.addEventListener("DOMContentLoaded", () => {
    desktopNav();
    mobileNav();
    scrollIntoContact();
})

// Insert placeholder images
const selectorList = ['.page-thumbnails',
    '.main-slider .swiper-slide',
    '.block-advert-banner-rotator__wrapper .swiper-slide',
    '.wp-block-blocks-pp-banner-block',
    '.block-cpt-rotator__img',
    '.block-cpt-rotator-2__img',
    '.rotator-shop-cards__img',
    '.block-advert-banner-one',
    '.service-career__item.active-thumb',
    '.block-cta-imageText__content-image',
    '.block-news__news-item-img',
    '.block-cpt-featured__testimonials-item-img',
    '.block-cpt-featured__featured-cpt-item-img',
    '.show-more__img',
    '.title-lead__gallery-slider-image',
    '.table-info__column-image-text.image-50 .table-info__column-image-text-1',
    '.accordion-content__item.image .accordion-content__item-img',
    '.block-cta-redirectionsList__image',
    '.block-mystamp__content-image',
    '.block-gallery__image',
    '.three-columns__column',
    '.block-cpt-archive__elements',
    '.table-info__single-image-img',
    '.divider-banner'];

const overlayElement = document.createElement('div');
overlayElement.classList = "image-temporary-overlay";

const heading = document.createElement('h2');
heading.innerText = "Materiał graficzny dostarczy PP";

const requiredImgSize = document.createElement('p');
requiredImgSize.classList = "overlay-img-size";
requiredImgSize.innerText = "wymagany rozmiar: ";

overlayElement.appendChild(heading);
overlayElement.appendChild(requiredImgSize);

function setImgOverlay() {
    selectorList.forEach((selector, selectorIndex) => {
        const itemList = document.querySelectorAll(selector);

        if (itemList.length !== 0) {
            itemList.forEach(imgContainer => {
                const img = imgContainer.querySelector('img');

                if (img) {
                    const imgAlt = img.alt;
                    const imgSrc = img.src.toLowerCase();

                    if (imgAlt.trim().length === 0 && !imgSrc.includes('svg')) {
                        imgContainer.appendChild(overlayElement.cloneNode(true));
                        imgContainer.style.position = "relative";
                        const sizeContainer = imgContainer.querySelector('.overlay-img-size');
                        const sizeText = document.createElement('span');

                        switch (selectorIndex) {
                            case 0:
                                sizeText.innerText = " 1920 x 313px";
                                sizeContainer.appendChild(sizeText);
                                break;
                            case 1:
                                sizeText.innerText = " 1920 x 545px";
                                sizeContainer.appendChild(sizeText);
                                break;
                            case 2:
                                imgContainer.querySelector('.image-temporary-overlay').style.borderRadius = "0 0 0" +
                                    " 200px";
                                if (window.innerWidth >= 1920) sizeText.innerText = " 1640 x 384px";
                                else if (window.innerWidth >= 990) sizeText.innerText = " 1200 x 384px";
                                else if (window.innerWidth < 990) sizeText.innerText = " 375 x 660px";
                                sizeContainer.appendChild(sizeText);
                                break;
                            case 3:
                            case 23:
                                sizeText.innerText = " 1920 x 384px";
                                sizeContainer.appendChild(sizeText);
                                break;
                            case 4:
                            case 5:
                            case 6:
                            case 21:
                                sizeText.innerText = " 1240 x 1240px";
                                imgContainer.querySelector('.image-temporary-overlay').style.height = '383px';
                                sizeContainer.appendChild(sizeText);
                                break;
                            case 7:
                                if (window.innerWidth >= 1920) sizeText.innerText = " 1920 x 384px";
                                else if (window.innerWidth >= 990) sizeText.innerText = " 1200 x 384px";
                                else if (window.innerWidth < 990) sizeText.innerText = " 375 x 660px";
                                imgContainer.querySelector('.image-temporary-overlay').style.borderRadius = "0 0 0" +
                                    " 200px";
                                sizeContainer.appendChild(sizeText);
                                break;
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 20:
                            case 22:
                                sizeText.innerText = " 1240 x 1240px";
                                sizeContainer.appendChild(sizeText);
                                break;
                            case 13:
                                sizeText.innerText = " 1240 x 1240px";
                                sizeContainer.appendChild(sizeText);
                                imgContainer.querySelector('.image-temporary-overlay').style.maxWidth = "458px";
                                imgContainer.querySelector('.image-temporary-overlay h2').style.fontSize = "32px";
                                imgContainer.querySelector('.image-temporary-overlay h2').style.lineHeight = "1.2";
                                break;
                            case 14:
                            case 19:
                                sizeText.innerText = " 1240 x 1240px";
                                sizeContainer.appendChild(sizeText);
                                imgContainer.querySelector('.image-temporary-overlay').style.gap = "0";
                                imgContainer.querySelector('.image-temporary-overlay h2').style.fontSize = "22px";
                                imgContainer.querySelector('.image-temporary-overlay h2').style.lineHeight = "1.2";
                                break;
                        }
                    }
                }
            })
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    setImgOverlay();
});

// let elements = document.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6');
// let text = ['Lorem', 'magna', 'lorem', 'ipsum'];
//
// [...elements].forEach(element => {
//     text.forEach(item => {
//         if (element.innerText.search(item) === -1) {
//
//         } else {
//             element.style.backgroundColor = 'rgba(26, 117, 255, 0.8)';
//             element.style.color = '#ffffff !important';
//         }
//     })
// })

// Set heading height in table info logotype block
window.addEventListener("load", () => {
    const LogotypeSection = document.querySelectorAll('.bsct-text-column');
    LogotypeSection.forEach(section => {
        const tiles = section.querySelectorAll('img');
        let threeElemArrays = [];
        for (let idx = 0; idx < [...tiles].length; idx += 2) {
            threeElemArrays.push([...tiles].slice(idx, idx + 2));
        }
        threeElemArrays.forEach(row => {
            const heights = row.map(tile => tile.offsetHeight);
            const maxHeights = Math.max(...heights);
            row.map(item => item.style.minHeight = `${maxHeights}px`);
        })
    })
}, true);